// extracted by mini-css-extract-plugin
export default {"Cars":"CollectionCar_Cars__lzxJH"};